import { CardPreview } from "common/firebase-function-types";
import { isEmptyOrUndefined } from "common/Support";
import { ButtonVNext } from "designer/ui/smart/button-vnext/button-vnext";
import { GlideFC } from "lib/glide-fc";
import { styled } from "sharedUI/styles";

const AppPlanBillingInfoContainer = styled.div`
    width: 100%;
    margin-bottom: 24px;

    .bold {
        font-weight: 700;
    }

    .med {
        font-size: 14px;
    }

    .sm {
        font-size: 13px;
    }

    .pale {
        color: ${p => p.theme.upgradeModal.planConfirm.color};
    }

    .accent {
        color: ${p => p.theme.b400};
        font-weight: 600;
    }

    .edit-billing {
        cursor: pointer;
    }

    > .section {
        margin-top: 8px;
        border-radius: 9px;
        border: 1px solid ${p => p.theme.upgradeModal.border};
        padding: 8px;
        display: flex;
        justify-content: space-between;

        > .billing-info {
            margin: 6px 18px 12px 10px;
            display: grid;
            grid-template-columns: 102px auto;
            column-gap: 24px;
            row-gap: 24px;

            > .cc-preview {
                display: flex;
                .last-four {
                    margin-left: 10px;
                }
            }
        }
    }
`;

interface Props {
    cardPreview: CardPreview;
    editBilling: () => void;
}

const AppPlanBillingInfo: GlideFC<Props> = p => {
    const { cardPreview, editBilling } = p;
    const { last4, address, email, name } = cardPreview;

    const line1 = name;

    let line2 = address.line1;
    if (!isEmptyOrUndefined(address.line2)) {
        line2 = `${line2}, ${address.line2}`;
    }

    if (!isEmptyOrUndefined(address.city) && !isEmptyOrUndefined(address.state)) {
        line2 = `${line2}, ${address.city}, ${address.state}`;
    }

    let line3 = "";
    if (!isEmptyOrUndefined(address.country) && !isEmptyOrUndefined(address.zip)) {
        line3 = `${address.country}, ${address.zip}`;
    }

    return (
        <AppPlanBillingInfoContainer>
            <div className="bold med">Billed to</div>
            <div className="section">
                <div className="billing-info">
                    <div className="cc-preview">
                        <div>
                            <img src="/images/generic-credit-card.svg" alt="cc-icon" />
                        </div>
                        <div className="med last-four">•••• {last4}</div>
                    </div>
                    <div className="sm pale">
                        <div>{line1}</div>
                        <div>{line2}</div>
                        <div>{line3}</div>
                    </div>

                    <div className="sm bold">Send Receipts</div>
                    <div className="med pale">{email}</div>
                </div>
                <ButtonVNext buttonType="minimal" variant="accent" label="Change" size="sm" onClick={editBilling} />
            </div>
        </AppPlanBillingInfoContainer>
    );
};

export default AppPlanBillingInfo;
